import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M0.5,-4h0.5v0.5h-0.5zM0.5,-3.5h1.5v0.5h-1.5zM0.5,-3h2v1h-2zM0,-2h3v0.5h-3zM-0.5,-1.5h3.5v0.5h-3.5zM-1.5,-1h4.5v0.5h-4.5zM-2.5,-0.5h5.5v0.5h-5.5zM-2,0h4v0.5h-4z',
    },
    {
      paint: 'rock',
      d: 'M-1,-4h1.5v0.5h-1.5zM-2,-3.5h2.5v0.5h-2.5zM-2.5,-3h3v0.5h-3zM-3,-2.5h3.5v0.5h-3.5zM-3,-2h3v0.5h-3zM-3,-1.5h2.5v0.5h-2.5zM-3,-1h1.5v0.5h-1.5z',
    },
  ],
  pixels: 88,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
